/**
 * Registry de providers de pago.
 *
 * Cada provider implementa la misma interfaz:
 *   - id, label, description, enabled, needsProofPerGroup
 *   - groupPayments(payments, ctx) → Array<group>
 *   - submitProof({ group, proofFile, user, cartGroupId, totalPaidOverride }) → Promise
 *
 * Hoy el único provider activo es `manualTransfer`. `mercadoPago` está stubbed
 * para validar la abstracción y queda listo para conectar la pasarela cuando
 * se decida activarla.
 */
import manualTransfer from "./manualTransfer";
import mercadoPago from "./mercadoPago";

const PROVIDERS = {
  [manualTransfer.id]: manualTransfer,
  [mercadoPago.id]: mercadoPago,
};

/**
 * Devuelve el provider activo para el contexto actual. Por ahora siempre el
 * manual, hasta que se habilite la pasarela. En el futuro podría depender
 * de configuración por edificio, feature flag global, o preferencia del
 * residente.
 */
export function getActiveProvider() {
  return manualTransfer;
}

/**
 * Lista los providers disponibles (ej. para mostrar selector si en algún
 * momento dejamos elegir al residente).
 */
export function listProviders() {
  return Object.values(PROVIDERS);
}

export { manualTransfer, mercadoPago };
export default PROVIDERS;
